import { EnumType, Enum } from 'ts-jenum';

@Enum<HeadsetManufacturerType>('value')
export class HeadsetManufacturerType extends EnumType<HeadsetManufacturerType>() {
   static readonly ALL = new HeadsetManufacturerType('ALL', 'common.types.headset_manufacturer.all');
   static readonly NONE = new HeadsetManufacturerType('NONE', 'common.types.headset_manufacturer.none');
   static readonly JABRA = new HeadsetManufacturerType('JABRA', 'common.types.headset_manufacturer.jabra');
   static readonly PLANTRONICS = new HeadsetManufacturerType('PLANTRONICS', 'common.types.headset_manufacturer.plantronics');
   static readonly SENNHEISER = new HeadsetManufacturerType('SENNHEISER', 'common.types.headset_manufacturer.sennheiser');

   private constructor(public value: string, public translationKey: string) {
      super();
   }
}
